export function Header() {
  return (
    <header className="header">
      <a className="brand" href="/">
        <span className="spark" aria-hidden="true">
          ✦
        </span>
        aniimo.codes
      </a>
      <em>Unofficial</em>
    </header>
  );
}
